<app-center-view title="Sign up" [isLoading]="isLoading" [error]="error">
  <div class="block">
    <div class="panes" [class]="activePane">
      <div>
        <app-sign-up-tos (goNext)="activePane = 'right'"></app-sign-up-tos>
      </div>
      <div>
        <app-sign-up-user
          (goBack)="activePane = 'left'"
          (isLoading)="isLoadingEvent($event)"
          (submit)="onSubmit($event)"
        ></app-sign-up-user>
      </div>
    </div>
  </div>
</app-center-view>
